import { createContext, useContext, useState, useCallback, PropsWithChildren } from "react";

interface InstructionsNavigationContextType {
  openImproveTab: () => void;
  activeTab: string | null;
  setActiveTab: (tab: string) => void;
  improveTabResetSignal: number | null;
}

const InstructionsNavigationContext = createContext<
  InstructionsNavigationContextType | undefined
>(undefined);

export function InstructionsNavigationProvider({ children }: PropsWithChildren) {
  const [activeTab, setActiveTabState] = useState<string | null>(null);
  const [improveTabResetSignal, setImproveTabResetSignal] =
    useState<number | null>(null);

  const openImproveTab = useCallback(() => {
    setActiveTabState("improve");
    setImproveTabResetSignal(Date.now());
  }, [setActiveTabState, setImproveTabResetSignal]);

  const setActiveTab = useCallback((tab: string) => {
    setActiveTabState(tab);
  }, []);

  return (
    <InstructionsNavigationContext.Provider
      value={{
        openImproveTab,
        activeTab,
        setActiveTab,
        improveTabResetSignal,
      }}
    >
      {children}
    </InstructionsNavigationContext.Provider>
  );
}

export function useInstructionsNavigation() {
  const context = useContext(InstructionsNavigationContext);
  if (context === undefined) {
    throw new Error(
      "useInstructionsNavigation must be used within InstructionsNavigationProvider"
    );
  }
  return context;
}
